// extracted by mini-css-extract-plugin
export default {"container":"UserQueue_container__D7boo","status":"UserQueue_status__p1KR7"};